import { DayOfWeek as p } from "@ancon/wildcat-types";
import { DaysOfWeekMap as y } from "../shared/constants.mjs";
import t from "../date/createLocalTimezoneMoment.mjs";
import u from "./getServiceIntervalsForOrderFormat.mjs";
import "moment";
function w(o, n, s) {
  return u(
    s,
    n
  ).reduce(
    (r, e) => {
      const i = e.dayOfWeek === p.Everyday, a = !!e.type, m = o.isoWeekday();
      if (i) {
        if (a) {
          const d = t(
            e.periodFrom
          ), f = t(e.periodTo);
          return o.isBetween(
            d,
            f,
            "day",
            "[]"
          ) && r.push(e), r;
        }
        return r.push(e), r;
      }
      return e.dayOfWeek === y[m] && r.push(e), r;
    },
    []
  );
}
export {
  w as default
};
